<template>
    <div class="row">
        <div class="col-6" v-if="zona_seleccionada.with_seats">
            <AsientosComponent :asientos_maximos="200" :abono_seleccionado="abono_seleccionado" :zona="zona_seleccionada" :asientos="datos_compradores" v-on:actualizarDatos="actualizarDatos" :puede_cambiar="true" :dia_abonado="false" :forzar_adyacentes="forzar_adyacentes"></AsientosComponent>
        </div>
        <div class="col-6" v-else>
            <div class="col-12">
                <p>Seleccione el numero de abonos</p>
                <div class="form-group">
                    <multiselect
                        v-model="n_abonos"
                        placeholder="Seleccionar zona"
                        :show-labels="false"
                        :options="options"
                        :allow-empty="false"
                        @select="actualizarDatos"
                    ></multiselect>
                </div>
            </div>
        </div>
        <div class="col-2"></div>
        <div class="col-4">
            <div class="row">
                <div class="col-12">
                    <SelectorZonaComponent :zona="zona_seleccionada" :zonas="zonas" v-on:changeZona="cambiarZona" :place="recinto"></SelectorZonaComponent>
                </div>
                <div class="col-12">
                    <TusAsientosComponent :asientos="datos_compradores" v-on:continuar="bloquearAsientos(3)" :configuracion_valida="configuracion_valida"></TusAsientosComponent>
                </div>
            </div>            
        </div>
    </div>
</template>

<script>
    import AsientosComponent from '@/components/backend/stepper/components/AsientosComponent';
    import SelectorZonaComponent from '@/components/backend/stepper/components/SelectorZonaComponent';
    import TusAsientosComponent from '@/components/backend/stepper/components/TusAsientosComponent';

    export default {
        props: ['zona', 'datos_compradores', 'abono_seleccionado'],
        data() {
            return {
                search: '',
                search_for: 'n_abonado',
                loading: true,
                zonas: null,
                zona_seleccionada: this.zona,
                n_abonos: 0,
                recinto: null,
                configuracion_valida: false,
                forzar_adyacentes: false
            }
        },
        created() {
            this.setPlace();
            
            this.getZonas();            
            if(this.manager.tipo != 1) {
                this.forzar_adyacentes = true;
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            place() {
                return this.$store.getters.getRecinto;
            },
            entradas_disponibles() {
                return this.zona_seleccionada.aforo - this.zona_seleccionada.confirmados - this.zona_seleccionada.no_confirmados;
            },
            options() {
                var tope = 10;

                if(this.entradas_disponibles < tope) {
                    tope = this.entradas_disponibles;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            }
        },
        watch: {
            n_abonos() {
                this.datos_compradores = [];
                for (var i = 0; i < this.n_abonos; i++) {
                    this.datos_compradores.push({
                        'apellidos': '',
                        'asiento': {
                            'zona_id': this.zona_seleccionada.id
                        },
                        'dni': '',
                        'es_nuevo': true,
                        'nombre': '',
                        'precio': null,
                        'precios': this.zona_seleccionada.precios,
                        'telefono': '',
                        'url_imprimir': ''
                    });
                }
            }
        },
        methods: {
            setPlace() {
                if(this.abono_seleccionado) {
                    this.recinto = this.abono_seleccionado.place;
                } else {
                    this.recinto = this.place;
                }
            },
            getZonas() {
                const params = {
                    filters: {
                        place_id: this.recinto.id
                    },
                    place_id: this.recinto.id
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                });
            },
            goTo(paso) {
                this.$emit('goTo', paso, this.datos_compradores);
            },
            actualizarDatos(datos, configuracion_valida) {
                this.datos_compradores = datos;

                if(this.manager.tipo != 1) {
                    this.configuracion_valida = configuracion_valida;
                }

                if(!this.forzar_adyacentes) {
                    this.configuracion_valida = true;
                }
            },
            cambiarZona(new_zona) {
                this.$emit('resetDatos', new_zona);
                this.n_abonos = 0;
                this.zona_seleccionada = new_zona;
            },
            bloquearAsientos (paso) {
                this.loading = true;

                var seats = [];

                for(var i in this.datos_compradores) {
                    //seats.push(this.asientos[i].asiento);
                    seats.push({
                        seat: this.datos_compradores[i].asiento.asiento,
                        row: this.datos_compradores[i].asiento.fila,
                        zona_id: this.datos_compradores[i].asiento.zona_id,
                        tipo_abono_id: this.abono_seleccionado ? this.abono_seleccionado.id : null,
                        lfp_id: this.datos_compradores[i].asiento.lfp_id ? this.datos_compradores[i].asiento.lfp_id : null,
                    });
                }

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    zona_id: this.zona_seleccionada.id,
                    asientos: seats,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    if(res.data.error) {
                        this.getZonas();
                        this.volver();
                        this.$toast.error(res.data.message);
                    } else {
                        this.session_id = res.data.session_id;

                        sessionStorage.setItem('session_id', this.session_id);

                        this.loading = false;
                        this.goTo(paso);
                    }

                }).catch(error => {
                    this.getZonas();
                    this.$toast.error('Butaca ya escogida o no hay stock');
                    console.log(error);
                    this.loading = false;
                });
            },
        },
        components: {
            AsientosComponent, SelectorZonaComponent, TusAsientosComponent
        }
    }
</script>

